var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": "",
        "show-close": false,
        visible: _vm.value,
        width: "350px",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "logout-tip-title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c("i", {
            staticClass: "el-icon-warning",
            staticStyle: {
              color: "#4292ff",
              "font-size": "20px",
              "margin-right": "10px",
            },
          }),
          _c("span", [_vm._v("下线提示")]),
        ]
      ),
      _c(
        "p",
        {
          staticClass: "logout-tip-content",
          staticStyle: { margin: "0 0 0 30px" },
        },
        [_vm._v(_vm._s(_vm.tips))]
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              staticStyle: { background: "#4292ff" },
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.close },
            },
            [_vm._v("我知道了")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }